import { Directive, inject } from '@angular/core';
import { ItemInfo, ListView, ListViewProviderDirective } from '@ntap/core';
import { ObrazacUnosaService } from './obrazac-unosa.service';

@Directive({
  selector: '[appObrasciViewProvider]',
  providers: [
    FastDataEntryObrasciListProviderDirective,
    {
      provide: ListViewProviderDirective,
      useExisting: FastDataEntryObrasciListProviderDirective
    }
  ]
})
export class FastDataEntryObrasciListProviderDirective extends ListViewProviderDirective<ListView> {
  private obrasciUnosaService = inject(ObrazacUnosaService);

  override addItem(item: object) {
    if (item) {
      this.obrasciUnosaService
        .refetchEntryTemplateOptionsAndSelectEntryTemplate(
          Number.parseInt(new ItemInfo(item).id)
        )
        .subscribe();
    } else {
      // u slucaju da smo obrisali, novi item je null
      this.obrasciUnosaService
        .refetchEntryTemplateOptionsAndSelectFirstTemplate()
        .subscribe();
    }
    super.addItem(item);
  }

  override updateItem(item: object, index: number): void {
    super.updateItem(item, index);
    this.obrasciUnosaService.refetchEntryTemplateOptionsAndSelectEntryTemplate(
      Number.parseInt(new ItemInfo(item).id)
    );
  }

  refreshPodrazineList() {
    this.reload();
  }
}
